import { useAuthenticator } from "@aws-amplify/ui-react";
import { getUrl } from "aws-amplify/storage";
import fetchClient from "common/functions/fetcher";
import { sanitizeAgreementHtml } from "common/functions/security";
import { CognitoUser } from "graphql/API";
import { useUserHooks } from "hooks/userHooks";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { AgreementDialogProps } from "./interfaces";

export const useAgreementDialogHooks = (props: AgreementDialogProps) => {
  const nodeRef = useRef(null);

  const { signOut } = useAuthenticator((context) => [context.signOut]);

  const [doc, setDoc] = useState("");
  const [agree, setAgree] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [confirm, setConfirm] = useState(false);

  const { busy: busyOfUser, agree: agreeOfUser } = useUserHooks(
    props.mainContext.userInfo?.username,
    props.mainContext.setFatal
  );

  const onAgreeChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void = useCallback((event, value) => {
    setAgree(value);
  }, []);

  const onOkButtonClick = useCallback(() => {
    agreeOfUser().then((value) => {
      if (value?.item) {
        props.onOkButtonClick(value.item as CognitoUser);
      }
    });
  }, [agreeOfUser, props]);

  const onLogoutButtonClick = useCallback(() => {
    signOut();
  }, [signOut]);

  const loadDoc = useCallback(
    () =>
      getUrl({
        path: "public/docs/agreement.md"
      })
        .then((url) => {
          if (url) {
            fetchClient
              .get<string>(url.url.href, { responseType: "text" })
              .then((response) => {
                setDoc(sanitizeAgreementHtml(response.data));
              })
              .catch(() => undefined);
          }
        })
        .catch(() => undefined),
    []
  );

  useEffect(() => {}, []);

  useEffect(() => {
    setTimeout(() => setBusy(busyOfUser), 0);
  }, [busyOfUser]);

  return {
    doc,
    setDoc,
    agree,
    setAgree,
    errorMessage,
    setErrorMessage,
    busy,
    setBusy,
    confirm,
    setConfirm,

    onAgreeChange,
    onOkButtonClick,
    onLogoutButtonClick,

    loadDoc,
    nodeRef
  } as const;
};
